/* F2R - Mercato : recherche, changement de club, cartes configurables, carrousel d'avis, barre de progression.
   Tout est delegue au document : le contenu peut etre remplace a tout moment sans reinitialisation.

   Deux particularites de ce theme, constatees en test :
   - une balise <script> inline posee a l'interieur d'une section ne s'execute pas de maniere fiable,
     donc meme les fleches du carrousel d'avis passent par la delegation ci-dessous ;
   - scrollBy({ behavior: 'smooth' }) ne deplace rien, quel que soit le scroll-snap,
     donc le carrousel est anime image par image (voir animateScroll), avec un filet de securite
     au cas ou requestAnimationFrame serait bride (onglet en arriere-plan). */
(function () {
  if (window.__f2rMercato) return;
  window.__f2rMercato = true;

  /* ---------- Suivi ---------- */
  if (!window.f2rMercatoTrack) {
    window.f2rMercatoTrack = function (name, payload) {
      var detail = { event: name, lp: 'mercato-f2r' };
      if (payload) {
        for (var k in payload) {
          if (Object.prototype.hasOwnProperty.call(payload, k)) detail[k] = payload[k];
        }
      }
      try { window.dataLayer = window.dataLayer || []; window.dataLayer.push(detail); } catch (e) {}
      try { document.dispatchEvent(new CustomEvent('f2r:mercato', { detail: detail })); } catch (e) {}
    };
  }

  var track = window.f2rMercatoTrack;

  function money(cents) {
    return '€' + (Math.round(cents) / 100).toFixed(2).replace('.', ',');
  }

  function root() { return document.querySelector('[data-f2r-mercato]'); }

  function conf(key, fallback) {
    var el = root();
    var value = el && el.getAttribute('data-' + key);
    return value === null || value === undefined || value === '' ? fallback : value;
  }

  function grid() { return document.querySelector('[data-f2rm-grid]'); }

  function drawerSectionId() {
    var drawer = document.querySelector('cart-drawer');
    var wrapper = drawer && drawer.closest('.shopify-section');
    return wrapper ? wrapper.id.replace('shopify-section-', '') : null;
  }

  function setMessage(card, text, kind) {
    var msg = card.querySelector('[data-f2rc-msg]');
    if (!msg) return;
    msg.textContent = text || '';
    msg.className = 'f2rc__msg' + (kind ? ' is-' + kind : '');
  }

  /* ---------- Quantite ---------- */
  function qtyInput(card) { return card.querySelector('[data-f2rc-qty-input]'); }

  function readQty(card) {
    var input = qtyInput(card);
    var value = parseInt(input && input.value, 10);
    if (isNaN(value) || value < 1) value = 1;
    if (value > 10) value = 10;
    return value;
  }

  function writeQty(card, value) {
    var input = qtyInput(card);
    if (input) input.value = value;
  }

  /* ---------- Ajout au panier ---------- */
  var adding = false;

  function addToCart(card) {
    if (adding) return;

    var sizes = card.querySelector('[data-f2rc-sizes]');
    var variantId = null;

    if (sizes) {
      var checked = sizes.querySelector('input:checked');
      if (!checked) {
        card.classList.add('is-missing-size');
        setMessage(card, conf('msg-size', 'Choisis ta taille'), 'error');
        var firstSize = sizes.querySelector('input:not(:disabled)');
        if (firstSize) firstSize.focus();
        return;
      }
      variantId = checked.value;
    } else {
      var single = card.querySelector('[data-f2rc-single]');
      variantId = single && single.value;
    }

    if (!variantId) return;
    card.classList.remove('is-missing-size');

    var quantity = readQty(card);
    var items = [];
    var properties = null;
    var floc = card.querySelector('[data-f2rc-floc]');
    var flocToggle = floc && floc.querySelector('[data-f2rc-floc-on]');
    var flocOn = !!(flocToggle && flocToggle.checked);

    if (flocOn) {
      /* Un seul champ : le client ecrit son flocage d'une traite ("SALIBA 3").
         On se contente de normaliser la casse et les espaces, le texte part tel quel en propriete de ligne. */
      var flocEl = floc.querySelector('[data-f2rc-floc-name]');
      var flocText = (flocEl && flocEl.value || '').replace(/\s+/g, ' ').trim().toUpperCase();

      if (!flocText) {
        setMessage(card, conf('msg-floc', 'Ajoute le nom a floquer'), 'error');
        if (flocEl) flocEl.focus();
        return;
      }

      properties = {};
      properties[conf('floc-property', 'Flocage')] = flocText;
    }

    var line = { id: Number(variantId), quantity: quantity };
    if (properties) line.properties = properties;
    items.push(line);

    if (flocOn) {
      var flocVariant = Number(floc.getAttribute('data-variant'));
      if (flocVariant) items.push({ id: flocVariant, quantity: quantity });
    }

    var button = card.querySelector('[data-f2rc-add]');
    var label = card.querySelector('[data-f2rc-add-label]');
    var original = label ? label.textContent : '';

    adding = true;
    if (button) button.disabled = true;
    if (label) label.textContent = conf('label-adding', 'Ajout...');
    setMessage(card, '', null);

    var payload = { items: items };
    var section = drawerSectionId();
    if (section) payload.sections = section;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) throw data;
          return data;
        });
      })
      .then(function (added) {
        return fetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            if (added && added.sections) cart.sections = added.sections;
            document.dispatchEvent(new CustomEvent('cart:change', { detail: { cart: cart } }));

            track('f2r_mercato_add_to_cart', {
              handle: card.getAttribute('data-handle'),
              quantity: quantity,
              flocage: flocOn
            });

            if (button) button.classList.add('is-done');
            if (label) label.textContent = conf('label-added', 'Ajoute');
            setMessage(card, conf('msg-added', ''), 'ok');

            setTimeout(function () {
              if (button) { button.classList.remove('is-done'); button.disabled = false; }
              if (label) label.textContent = original;
              setMessage(card, '', null);
            }, 2200);
          });
      })
      .catch(function (error) {
        var text = (error && (error.description || error.message)) || conf('msg-error', 'Impossible d ajouter cet article');
        setMessage(card, text, 'error');
        if (button) button.disabled = false;
        if (label) label.textContent = original;
      })
      .then(function () { adding = false; });
  }

  /* ---------- Chargement de la grille (clubs et recherche) ---------- */
  var pending = null;

  function loadGrid(url, onFail) {
    var target = grid();
    if (!target || !url || !('fetch' in window) || !('DOMParser' in window)) return false;

    var sectionId = target.getAttribute('data-section-id');
    target.setAttribute('aria-busy', 'true');

    if (pending) pending.abort();
    pending = typeof AbortController === 'function' ? new AbortController() : null;

    fetch(url + (url.indexOf('?') === -1 ? '?' : '&') + 'section_id=' + sectionId, pending ? { signal: pending.signal } : undefined)
      .then(function (response) { return response.ok ? response.text() : Promise.reject(); })
      .then(function (html) {
        var next = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-f2rm-grid]');
        if (!next) return Promise.reject();
        target.innerHTML = next.innerHTML;
        target.removeAttribute('aria-busy');
      })
      .catch(function (error) {
        if (error && error.name === 'AbortError') return;
        target.removeAttribute('aria-busy');
        if (typeof onFail === 'function') onFail();
      });

    return true;
  }

  function clearTiles() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-f2rm-tile]'), function (tile) {
      tile.removeAttribute('aria-current');
    });
  }

  function markTile(handle) {
    clearTiles();
    if (!handle) return;
    var tile = document.querySelector('[data-f2rm-tile][data-handle="' + handle + '"]');
    if (tile) tile.setAttribute('aria-current', 'true');
  }

  function collectionUrl(handle) {
    return '/collections/' + handle + '?sort_by=' + conf('collection-sort', 'best-selling');
  }

  function searchUrl(term) {
    return '/search?type=product&options%5Bprefix%5D=last&q=' + encodeURIComponent(term);
  }

  /* ---------- Recherche ---------- */
  /* Les titres produits ne contiennent pas de noms de joueurs : une recherche brute sur "mbappe"
     ne renvoie rien de pertinent. On passe donc par, dans l'ordre :
       1. la table de correspondance du reglage « Correspondances de recherche » (joueur -> collection),
       2. les collections que Shopify reconnait lui-meme (clubs, pays, categories),
       3. la recherche produit classique.
     Une collection est toujours chargee triee par ventes : le best-seller remonte en premier. */

  function normalize(value) {
    var text = (value === null || value === undefined) ? '' : String(value);
    text = text.toLowerCase();
    try { text = text.normalize('NFD').replace(/[̀-ͯ]/g, ''); } catch (e) {}
    return text.replace(/[^a-z0-9]+/g, ' ').replace(/\s+/g, ' ').trim();
  }

  var aliasTable = null;

  function aliases() {
    if (aliasTable) return aliasTable;
    aliasTable = {};
    var raw = conf('search-aliases', '');
    raw.split(/[\n;]+/).forEach(function (line) {
      var split = line.indexOf('=');
      if (split === -1) return;
      var target = line.slice(split + 1).trim();
      if (!target) return;
      line.slice(0, split).split(',').forEach(function (term) {
        var key = normalize(term);
        if (key) aliasTable[key] = target;
      });
    });
    return aliasTable;
  }

  function aliasFor(query) {
    var table = aliases();
    var text = normalize(query);
    if (!text) return null;
    if (table[text]) return table[text];

    var padded = ' ' + text + ' ';
    var best = null;
    var bestLength = 0;
    for (var key in table) {
      if (!Object.prototype.hasOwnProperty.call(table, key)) continue;
      if (key.length < 3 || key.length <= bestLength) continue;
      if (padded.indexOf(' ' + key + ' ') !== -1) { best = table[key]; bestLength = key.length; }
    }
    return best;
  }

  function suggestCollection(query) {
    if (!('fetch' in window)) return Promise.resolve(null);
    var url = '/search/suggest.json?q=' + encodeURIComponent(query) + '&resources%5Btype%5D=collection&resources%5Blimit%5D=4';
    return fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (response) { return response.ok ? response.json() : null; })
      .then(function (data) {
        var list = data && data.resources && data.resources.results && data.resources.results.collections;
        if (!list || !list.length) return null;
        var text = normalize(query);
        var loose = null;
        for (var i = 0; i < list.length; i++) {
          var title = normalize(list[i].title);
          if (!title) continue;
          if (title === text || title.indexOf(text) === 0) return list[i].handle;
          if (!loose && (title.indexOf(text) !== -1 || text.indexOf(title) !== -1)) loose = list[i].handle;
        }
        return loose;
      })
      .catch(function () { return null; });
  }

  var lastQuery = null;
  var searchTimer = null;

  function resetGrid() {
    if (lastQuery === '') return;
    lastQuery = '';
    var target = grid();
    var url = target && target.getAttribute('data-default-url');
    clearTiles();
    var firstTile = document.querySelector('[data-f2rm-tile]');
    if (firstTile) firstTile.setAttribute('aria-current', 'true');
    if (url) loadGrid(url);
  }

  function runSearch(term) {
    var query = (term || '').trim();
    if (query.length < 2) { resetGrid(); return; }
    if (query === lastQuery) return;
    lastQuery = query;

    var mapped = aliasFor(query);
    if (mapped) {
      if (mapped.indexOf('q:') === 0) {
        var forced = mapped.slice(2).trim();
        clearTiles();
        track('f2r_mercato_search', { query: query, resolved: forced, via: 'alias-query' });
        loadGrid(searchUrl(forced));
      } else {
        markTile(mapped);
        track('f2r_mercato_search', { query: query, resolved: mapped, via: 'alias-collection' });
        loadGrid(collectionUrl(mapped));
      }
      return;
    }

    clearTiles();
    suggestCollection(query).then(function (handle) {
      if (query !== lastQuery) return;
      if (handle) {
        markTile(handle);
        track('f2r_mercato_search', { query: query, resolved: handle, via: 'collection' });
        loadGrid(collectionUrl(handle));
        return;
      }
      track('f2r_mercato_search', { query: query, via: 'products' });
      loadGrid(searchUrl(query));
    });
  }

  function searchInput() { return document.querySelector('[data-f2rm-search-input]'); }

  function toggleClear() {
    var input = searchInput();
    var clear = document.querySelector('[data-f2rm-search-clear]');
    if (input && clear) clear.hidden = !input.value;
  }

  /* La frappe est captee sur input ET keyup : certains widgets tiers et claviers
     virtuels ne declenchent pas input de maniere fiable. */
  function onTyping(event) {
    var field = event.target.closest ? event.target.closest('[data-f2rm-search-input]') : null;
    if (field) {
      toggleClear();
      clearTimeout(searchTimer);
      var value = field.value;
      searchTimer = setTimeout(function () { runSearch(value); }, 300);
      return;
    }

    if (event.type !== 'input') return;

    var flocEl = event.target.closest('[data-f2rc-floc-name]');
    if (flocEl) {
      var start = flocEl.selectionStart;
      var upper = flocEl.value.toUpperCase();
      if (upper !== flocEl.value) {
        flocEl.value = upper;
        try { flocEl.setSelectionRange(start, start); } catch (e) {}
      }
    }
  }

  /* ---------- Carrousel d'avis ---------- */
  /* scrollBy({ behavior: 'smooth' }) est inoperant sur ce theme : on anime a la main,
     en desactivant le scroll-snap pendant l'animation pour qu'il ne la combatte pas.
     Le setTimeout final garantit l'arrivee meme si requestAnimationFrame est bride. */
  function animateScroll(rail, delta) {
    var start = rail.scrollLeft;
    var limit = rail.scrollWidth - rail.clientWidth;
    var target = Math.max(0, Math.min(start + delta, limit));
    if (target === start) return;

    var snap = rail.style.scrollSnapType;
    var settled = false;
    var duration = 320;

    function finish() {
      if (settled) return;
      settled = true;
      rail.scrollLeft = target;
      rail.style.scrollSnapType = snap;
    }

    if (!('requestAnimationFrame' in window)) { finish(); return; }

    rail.style.scrollSnapType = 'none';

    var origin = null;

    function frame(now) {
      if (settled) return;
      if (origin === null) origin = now;
      var progress = Math.min(1, (now - origin) / duration);
      var eased = progress < 0.5 ? 2 * progress * progress : -1 + (4 - 2 * progress) * progress;
      rail.scrollLeft = start + (target - start) * eased;
      if (progress < 1) { requestAnimationFrame(frame); } else { finish(); }
    }

    requestAnimationFrame(frame);
    setTimeout(finish, duration + 220);
  }

  function scrollReviews(button) {
    var scope = button.closest('.shopify-section') || document;
    var rail = scope.querySelector('[data-f2ra-slider]');
    if (!rail) return;
    var first = rail.querySelector('li');
    var distance = first ? first.getBoundingClientRect().width + 12 : rail.clientWidth * 0.8;
    animateScroll(rail, button.hasAttribute('data-f2ra-next') ? distance : -distance);
  }

  /* ---------- Delegation ---------- */
  document.addEventListener('click', function (event) {
    var arrow = event.target.closest('[data-f2ra-prev], [data-f2ra-next]');
    if (arrow) { scrollReviews(arrow); return; }

    var card = event.target.closest('[data-f2rc]');

    if (card) {
      if (event.target.closest('[data-f2rc-inc]')) { writeQty(card, Math.min(10, readQty(card) + 1)); return; }
      if (event.target.closest('[data-f2rc-dec]')) { writeQty(card, Math.max(1, readQty(card) - 1)); return; }
      if (event.target.closest('[data-f2rc-add]')) { addToCart(card); return; }
    }

    var hint = event.target.closest('[data-f2rm-hint]');
    if (hint) {
      var input = searchInput();
      if (input) { input.value = hint.getAttribute('data-term') || hint.textContent.trim(); toggleClear(); }
      runSearch(input ? input.value : '');
      return;
    }

    if (event.target.closest('[data-f2rm-search-clear]')) {
      var field = searchInput();
      if (field) { field.value = ''; field.focus(); }
      toggleClear();
      resetGrid();
      return;
    }

    var tile = event.target.closest('[data-f2rm-tile]');
    if (tile && !event.metaKey && !event.ctrlKey && !event.shiftKey && event.button === 0) {
      var url = tile.getAttribute('href');
      if (!url) return;
      event.preventDefault();

      var box = searchInput();
      if (box) { box.value = ''; toggleClear(); }

      lastQuery = null;
      clearTiles();
      tile.setAttribute('aria-current', 'true');
      track('f2r_mercato_club_select', { collection: tile.getAttribute('data-handle') });
      loadGrid(url, function () { window.location.href = url; });

      if (tile.hasAttribute('data-f2rm-focus-search') && box) {
        try { box.scrollIntoView({ block: 'center' }); } catch (e) { box.scrollIntoView(); }
        setTimeout(function () { box.focus(); }, 260);
        track('f2r_mercato_search_prompt', {});
      }
    }
  });

  document.addEventListener('submit', function (event) {
    if (event.target.closest('[data-f2rm-search]')) {
      event.preventDefault();
      var input = searchInput();
      clearTimeout(searchTimer);
      runSearch(input ? input.value : '');
    }
  });

  document.addEventListener('change', function (event) {
    var toggle = event.target.closest('[data-f2rc-floc-on]');
    if (toggle) {
      var wrap = toggle.closest('[data-f2rc-floc]');
      var fields = wrap && wrap.querySelector('[data-f2rc-floc-fields]');
      if (fields) {
        fields.hidden = !toggle.checked;
        if (toggle.checked) {
          var first = fields.querySelector('input');
          if (first) first.focus();
          track('f2r_mercato_flocage_open', {});
        }
      }
      return;
    }

    var size = event.target.closest('[data-f2rc-sizes] input');
    if (size) {
      var card = size.closest('[data-f2rc]');
      if (card) { card.classList.remove('is-missing-size'); setMessage(card, '', null); }
    }
  });

  document.addEventListener('input', onTyping);
  document.addEventListener('keyup', onTyping);

  /* ---------- Barre de progression ---------- */
  var lastCount = null;

  function paintBar(cart) {
    var bar = document.querySelector('[data-f2rmp]');
    if (!bar) return;

    var vendor = bar.getAttribute('data-option-vendor') || '';
    var count = 0;
    (cart.items || []).forEach(function (item) {
      if (vendor && item.vendor === vendor) return;
      count += item.quantity;
    });

    var modulo = count % 2;
    var ready = count > 0 && modulo === 0;
    var msg = bar.querySelector('[data-f2rmp-msg]');
    var sub = bar.querySelector('[data-f2rmp-sub]');
    var fill = bar.querySelector('[data-f2rmp-fill]');
    var cta = bar.querySelector('[data-f2rmp-cta]');
    var key = count === 0 ? 'empty' : (ready ? 'ready' : 'odd');

    if (msg) msg.textContent = (bar.getAttribute('data-msg-' + key) || '').replace('[n]', String(count));

    if (sub) {
      var subText = bar.getAttribute('data-sub-' + key) || '';
      if (key === 'ready' && cart.total_discount > 0) {
        subText = (bar.getAttribute('data-sub-saved') || '').replace('[montant]', money(cart.total_discount));
      }
      sub.textContent = subText.replace('[n]', String(count));
    }

    if (fill) fill.style.width = (count === 0 ? 0 : (ready ? 100 : 50)) + '%';
    bar.classList.toggle('is-ready', ready);
    bar.classList.toggle('is-visible', count > 0 || bar.getAttribute('data-always') === 'true');
    if (cta) cta.hidden = count === 0;

    if (lastCount !== null && count > lastCount) {
      if (count === 2) track('f2r_mercato_second_jersey_added', { eligible_items: count });
      if (cart.total_discount > 0) {
        track('f2r_mercato_discount_visible', { discount_cents: cart.total_discount, eligible_items: count });
      }
    }
    lastCount = count;
  }

  function refreshBar() {
    if (!document.querySelector('[data-f2rmp]')) return;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) { if (cart) paintBar(cart); })
      .catch(function () {});
  }

  document.addEventListener('cart:change', function () { setTimeout(refreshBar, 60); });

  document.addEventListener('click', function (event) {
    if (event.target.closest('[name="checkout"], .shopify-payment-button__button')) {
      track('f2r_mercato_checkout_start', { eligible_items: lastCount });
    }
  });

  function start() {
    track('f2r_mercato_page_view', {});
    toggleClear();
    refreshBar();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
